import { ESymbolCategory, ISymbol } from "@kuika/kuika-cl-model/src/models/builder.dtos";

/**
 * Hover text for the Value cell; empty means no tooltip. Only input-backed categories
 * get one — label-style ones already carry SymbolPicker's own tooltip, and a second
 * would stack two balloons.
 */
export const getParamSymbolHoverText = (symbol?: ISymbol): string => {
  // Falls back to the placeholder: on an empty row that is the cut-off text.
  if (symbol?.category === ESymbolCategory.sqlParameter) {
    return symbol.sqlParamName || "SQL Param";
  }
  if (symbol?.category !== ESymbolCategory.fixed) {
    return "";
  }
  const fixedValue: unknown = symbol.fixedValue;
  // Primitives only: a date value is a dayjs object and prints "[object Object]".
  if (typeof fixedValue === "string") {
    return fixedValue;
  }
  if (typeof fixedValue === "number" || typeof fixedValue === "boolean") {
    return String(fixedValue);
  }
  return "";
};
